// extracted by mini-css-extract-plugin
export default {"wrapper":"FolderItem_wrapper__3fGe2","delete_button":"FolderItem_delete_button__FQwXh","name":"FolderItem_name__eEGBl","image_wrapper":"FolderItem_image_wrapper__FwBQE"};